<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <div style="position: relative;">
        <dv-decoration-7>　{{title}}　</dv-decoration-7>
        <div v-if="title2" class="title2 box_v box_center">
          <div><span style="font-size: 15px;">总消费：</span><span style="color: rgb(255, 252, 134)">{{title2}}</span></div>
        </div>
      </div>
      <div class="box_f1">
        <dv-border-box-8>
          <dv-scroll-board :config="config" />
        </dv-border-box-8>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'csscAllTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      this.config = this.getConfig([['', '', '', '']])
      //4大类总消费金额排名
      //04--超市，05--商场,06--家电，07--金银珠宝,
      //12,13,14汽车
      this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/top',{
        discountCouponTypeNO: this.type
      },res=> {
        let data = res.rows.map(item=> {
          return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
            '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
            '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>']
        })
        this.config = this.getConfig(data)
      })
    },
    methods: {
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '', '']]
        }
        return {
          header: ['企业名称', '消费总金额(元)', '核销总数(张)'],
          data: data,
          index: true,
          waitTime: 3000,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          columnWidth: [50, 230],
          align: ['center', 'left', 'center','center']
        }
      },
      toThousands(_num, bol) {
        _num = _num.toFixed(4)*1
        let numArr = (_num+'').split('.')
        let num = parseInt(numArr[0])
        let xs = numArr[1]?numArr[1]:''

        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(xs) {
          result = [...result, '.', ...xs.split('')]
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      },
      _toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        config: {}
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      title2: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-8 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
    .title2 {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      font-size: 18px;
    }
  }
</style>
